import templateUrl from 'emun.vendor/vendor-dashboard.htm'
import controller from 'emun.vendor/vendor-dashboard.controller'


let VendorDashboard = {
    bindings: {
        vendorId: '@'
    },
    require:{
        container: '^vendorContainer'
    },
    controller,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}

export default VendorDashboard